"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.keyCodes = void 0;
const keyCodes = exports.keyCodes = {
  enter: 13
};